module.exports = __webpack_public_path__ + "img/logo-client.ba7495b7.png";